import { mmHttp, MmRequestConfig } from './mmHttp';
import { readPage } from './pagination';
import { MmTaskItem } from '../types/domain';
import { MmPage } from '../types/dto';

const MONITORING_TASKS_PATH = '/monitoring/tasks';

export function fetchTaskItems(
  taskId: string,
  pageParams: { [key: string]: any },
  config?: MmRequestConfig,
): Promise<MmPage<MmTaskItem>> {
  return mmHttp
    .get(
      MONITORING_TASKS_PATH + '/' + encodeURIComponent(taskId) + '/items',
      Object.assign({ params: pageParams, mmSection: 'tasks/items' }, config),
    )
    .then((response) => readPage<MmTaskItem>(response.data));
}
